import { t } from "../i18n";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { LocateMeButton } from "./LocateMeButton";

export function Header() {
  return (
    <header class="header">
      <div class="header-title">⛽ {t("app_title")}</div>
      <div class="header-actions">
        {/* Fullweb variants (/paliwo /fuel /sprit /carburant) lock the language
           via Wrapper, so the manual switcher would be misleading — hide it.
           Embed/widget builds (__FULL__ = false) still show it. esbuild folds
           the literal away → no LanguageSwitcher in fullweb bundles. */}
        {!__FULL__ && <LanguageSwitcher />}
        <LocateMeButton />
      </div>
    </header>
  );
}
